<template>
  <div
    v-show="showing"
    id="mini"
    class="absolute rounded-lg shadow-lg ml-16 w-64 bg-gray-100"
  >
    <div class="relative cursor-pointer" v-on:click="mapa('traffic')">
      <img src="@/assets/streets.png" class="bg-red-200 w-64 h-40 mb-1" />
      <span
        class="absolute inset-x-0 bottom-0 bg-gray-700 text-gray-100 uppercase tracking-wide py-1"
        >Mapa de calles</span
      >
    </div>
    <div class="relative cursor-pointer" v-on:click="mapa('satellite')">
      <img src="@/assets/satellite.png" class="bg-red-200 w-64 h-40 my-1" />
      <span
        class="absolute inset-x-0 bottom-0 bg-gray-700 text-gray-100 uppercase tracking-wide py-1"
        >Mapa de satélite</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "control-map",

  data: function () {
    return {};
  },
  props: {
    showing: {
      required: true,
      type: Boolean,
    },
  },
  methods: {
    mapa: function (map) {
      this.$emit("click", {
        mapa: map,
      });
    },
  },
};
</script>

<style scoped></style>
